import React, { useState, useRef, useEffect } from 'react';
const ApplyNow = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isProgramDropdownOpen, setIsProgramDropdownOpen] = useState(false);
  const [isIntakeDropdownOpen, setIsIntakeDropdownOpen] = useState(false);
  const programDropdownRef = useRef(null);
  const intakeDropdownRef = useRef(null);
  const [formData, setFormData] = useState({
    firstName: '',
    fatherName: '',
    email: '',
    phone: '',
    dateOfBirth: '',
    lastQualification: '',
    program: '',
    languageCourse: '',
    referenceName: '',
    nationality: '',
    highestQualification: '',
    intake: '',
    address: '',
    message: '',
    photo: null
  });
  
  const [photoPreview, setPhotoPreview] = useState('');
  const [photoError, setPhotoError] = useState('');

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (programDropdownRef.current && !programDropdownRef.current.contains(event.target)) {
        setIsProgramDropdownOpen(false);
      }
      if (intakeDropdownRef.current && !intakeDropdownRef.current.contains(event.target)) {
        setIsIntakeDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleProgramDropdown = () => {
    setIsProgramDropdownOpen(!isProgramDropdownOpen);
  };

  const selectProgram = (program) => {
    setFormData(prev => ({
      ...prev,
      program: program
    }));
    setIsProgramDropdownOpen(false);
  };


  const programs = [
    'Business and Management',
    'Marketing',
    'Health and Social Care',
    'Psychology',
    'Health and Safety Management',
    'Hospitality and Tourism Management',
    'Human Resource Management',
    'Accounting and Finance',
    'Law and Legal Services',
    'Information Technology',
    'Data Science',
    'Cyber Security',
    'Logistics and Supply Chain Management',
    'Early Years Education',
    'Education and Training',
    'Teaching and Coaching',
    'Sports Coaching',
    'Aesthetic Practice',
    'Beauty Therapy',
    'Hairdressing',
    'Wellness'
  ];

  const languageCourses = [
    'IELTS',
    'TOEFL',
    'Oxford ELT',
    'Duolingo',
    'PSI',
    'Language CERT',
    'PTE'
  ];

  const qualifiPrograms = [
    'Qualifi Level 3 Diploma in Business Management (603/1102/2)',
    'Qualifi Level 3 Diploma in Introduction to Management (603/4373/4)',
    'Qualifi Level 3 Integrated Diploma in Business and Management (603/4730/2)',
    'Qualifi Level 3 Diploma in Business Innovation and Entrepreneurship (603/1051/0)',
    'Qualifi Level 3 Extended Diploma in Business, Management and Study Skills (603/7380/5)',
    'Qualifi Level 3 Extended Diploma in Business Management (610/5596/7)',
    'Qualifi Level 3 Extended Diploma in Business and Law (610/5595/5)',
    'Qualifi Level 4 Diploma in Entrepreneurship (603/4238/9)',
    'Qualifi Level 4 Diploma in Business Management (601/6048/2)',
    'Qualifi Level 4 Diploma in Innovation and Future Foresight (610/2084/9)',
    'Qualifi Level 5 Diploma in Business Enterprise (601/6050/0)',
    'Qualifi Level 5 Diploma in Business Management (601/6049/4)',
    'Qualifi Level 5 Extended Diploma in Business Management (610/1675/5)',
    'Qualifi Level 6 Diploma in Business Administration (603/1037/6)',
    'Qualifi Level 6 Diploma in Business Management, Leadership and Innovation (603/7473/1)',
    'Qualifi Level 7 Diploma in Business Strategy (603/5745/9)',
    'Qualifi Level 7 Diploma in Ethical Leadership (603/4994/3)',
    'Qualifi Level 7 Diploma in Executive Management (601/7656/8)',
    'Qualifi Level 7 Diploma in Strategic Management and Innovation (603/2900/2)',
    'Qualifi Level 7 Diploma in Strategic Management and Leadership (601/5335/0)',
    'Qualifi Level 7 Diploma in Project Management (610/1342/0)',
    'Qualifi Level 7 Diploma in Risk Management (610/2175/1)'
  ];
  
  const toggleIntakeDropdown = () => {
    setIsIntakeDropdownOpen(!isIntakeDropdownOpen);
  };
  
  const selectIntake = (program) => {
    setFormData(prev => ({
      ...prev,
      intake: program
    }));
    setIsIntakeDropdownOpen(false);
  };



  const handleChange = (e) => {
    const { name, value, files } = e.target;
    // Skip program field as it's handled by the custom dropdown
    if (name === 'program') return;
    
    // Handle file upload
    if (name === 'photo' && files && files[0]) {
      const file = files[0];
      
      // Validate file type
      const validTypes = ['image/jpeg', 'image/png', 'image/jpg'];
      if (!validTypes.includes(file.type)) {
        setPhotoError('Please upload a valid image file (JPEG, JPG, or PNG)');
        return;
      }
      
      // Validate file size (5MB max)
      const maxSize = 5 * 1024 * 1024; // 5MB
      if (file.size > maxSize) {
        setPhotoError('File size must be less than 5MB');
        return;
      }
      
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPhotoPreview(reader.result);
        setPhotoError('');
      };
      reader.readAsDataURL(file);
      
      setFormData(prev => ({
        ...prev,
        [name]: file
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };
  
  const removePhoto = () => {
    setPhotoPreview('');
    setFormData(prev => ({
      ...prev,
      photo: null
    }));
    // Reset file input
    const fileInput = document.getElementById('photo');
    if (fileInput) fileInput.value = '';
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Check if photo is required
    if (formData.photo) {
      if (formData.photo.size > 5 * 1024 * 1024) {
        setPhotoError('File size must be less than 5MB');
        setIsSubmitting(false);
        return;
      }
    }
    
    try {
      const formDataToSend = new FormData();
      
      // Append all form data to FormData object
      Object.keys(formData).forEach(key => {
        if (formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      });
      
      // Simulate API call with FormData
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Log form data (in a real app, you would send this to your server)
      console.log('Form submitted with data:', Object.fromEntries(formDataToSend));
      
      // Show success message
      alert('Thank you for your application! We will contact you soon.');
      
      // Reset form
      setFormData({
        firstName: '',
        fatherName: '',
        email: '',
        phone: '',
        dateOfBirth: '',
        lastQualification: '',
        program: '',
        languageCourse: '',
        nationality: '',
        highestQualification: '',
        intake: '',
        address: '',
        message: '',
        photo: null
      });
      
      setPhotoPreview('');
      setPhotoError('');
      
      // Reset file input
      const fileInput = document.getElementById('photo');
      if (fileInput) fileInput.value = '';
      
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-primary py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Apply Now</h1>
          <p className="text-xl text-white opacity-90">
            Start your application to join our community of learners and innovators.
          </p>
        </div>
      </div>

      {/* Application Form */}
      <div className="py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-lg shadow-lg overflow-hidden">
            <div className="p-8">
              <div className="mb-8">
                <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4">
                  <div className="w-full">
                    <h2 className="text-2xl font-bold text-gray-800 text-center">Application Form</h2>
                    <p className="text-gray-600 mt-2 text-center">Please fill out the form below to start your application.</p>
                  </div>
                  
                  {/* Photo Upload Box */}
                  <div className="w-full md:w-48 border border-gray-200 rounded-lg p-4 shadow-sm bg-white">
                    <div className="flex flex-col items-center">
                      <label htmlFor="photo" className="block text-sm font-medium text-gray-700 mb-2">
                        Upload Photo (Optional)
                      </label>
                      <div className="relative">
                        <label
                          htmlFor="photo"
                          className="cursor-pointer flex flex-col items-center justify-center w-32 h-24 border-2 border-dashed border-gray-300 rounded-lg hover:border-primary transition-colors"
                        >
                          {photoPreview ? (
                            <img
                              src={photoPreview}
                              alt="Preview"
                              className="w-full h-full object-cover rounded-md"
                            />
                          ) : (
                            <>
                              <svg className="w-8 h-8 text-gray-400 mb-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                              </svg>
                              <span className="text-xs text-gray-500 text-center px-2">JPG, PNG<br/>Max 5MB</span>
                            </>
                          )}
                        </label>
                        {photoPreview && (
                          <button
                            type="button"
                            onClick={removePhoto}
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
                            title="Remove photo"
                          >
                            <svg className="h-3 w-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                        )}
                        <input
                          id="photo"
                          name="photo"
                          type="file"
                          accept="image/jpeg, image/png, image/jpg"
                          onChange={handleChange}
                          className="hidden"
                        />
                      </div>
                      {photoError && (
                        <p className="mt-1 text-xs text-red-600 text-center">{photoError}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
              <form onSubmit={handleSubmit} className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                      First Name *
                    </label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label htmlFor="fatherName" className="block text-sm font-medium text-gray-700 mb-1">
                      Father's Name *
                    </label>
                    <input
                      type="text"
                      id="fatherName"
                      name="fatherName"
                      value={formData.fatherName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                      Email Address *
                    </label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                      Phone Number *
                    </label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">Address *</label>
                  <textarea
                    id="address"
                    name="address"
                    rows="3"
                    value={formData.address}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder="123 Main St, Anytown, USA 12345"
                  ></textarea>
                </div>



                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="dateOfBirth" className="block text-sm font-medium text-gray-700 mb-1">
                      Date of Birth *
                    </label>
                    <input
                      type="date"
                      id="dateOfBirth"
                      name="dateOfBirth"
                      value={formData.dateOfBirth}
                      onChange={handleChange}
                      required
                      max={new Date().toISOString().split('T')[0]}
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>
                  <div>
                    <label htmlFor="lastQualification" className="block text-sm font-medium text-gray-700 mb-1">
                      Last Qualification *
                    </label>
                    <input
                      type="text"
                      id="lastQualification"
                      name="lastQualification"
                      value={formData.lastQualification}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <div className="mb-4">
                      <label htmlFor="program" className="block text-sm font-medium text-gray-700 mb-1">
                        Program of Interest *
                      </label>
                      <div className="relative" ref={programDropdownRef}>
                        <button
                          type="button"
                          onClick={toggleProgramDropdown}
                          className="w-full text-left px-4 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent flex justify-between items-center"
                        >
                          <span className="truncate">{formData.program || 'Select a program'}</span>
                          <svg className={`h-5 w-5 text-gray-500 transform transition-transform ${isProgramDropdownOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </button>
                        {isProgramDropdownOpen && (
                          <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                            {programs.map((program) => (
                              <div
                                key={program}
                                className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${formData.program === program ? 'bg-blue-50' : ''}`}
                                onClick={() => selectProgram(program)}
                              >
                                {program}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      <input
                        type="hidden"
                        name="program"
                        value={formData.program}
                        required
                      />
                    </div>
                  </div>
                  <div className="mb-4">
                    <label htmlFor="intake" className="block text-sm font-medium text-gray-700 mb-1">
                      Select Program *
                    </label>
                    <div className="relative" ref={intakeDropdownRef}>
                      <button
                        type="button"
                        onClick={toggleIntakeDropdown}
                        className="w-full text-left px-4 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent flex justify-between items-center"
                      >
                        <span className="truncate">{formData.intake || 'Select a program'}</span>
                        <svg className={`h-5 w-5 text-gray-500 transform transition-transform ${isIntakeDropdownOpen ? 'rotate-180' : ''}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </button>
                      {isIntakeDropdownOpen && (
                        <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                          {qualifiPrograms.map((program) => (
                            <div
                              key={program}
                              className={`px-4 py-2 hover:bg-gray-100 cursor-pointer ${formData.intake === program ? 'bg-blue-50' : ''}`}
                              onClick={() => selectIntake(program)}
                            >
                              {program}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                    <input
                      type="hidden"
                      name="intake"
                      value={formData.intake}
                      required
                    />
                  </div>
                </div>

                <div className="space-y-2">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label htmlFor="languageCourse" className="block text-sm font-medium text-gray-700 mb-1">Language Course *</label>
                      <select
                        id="languageCourse"
                        name="languageCourse"
                        value={formData.languageCourse}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                      >
                        <option value="">Select language course</option>
                        {languageCourses.map((course) => (
                          <option key={course} value={course}>
                            {course}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label htmlFor="referenceName" className="block text-sm font-medium text-gray-700 mb-1">Reference Name</label>
                      <input
                        type="text"
                        id="referenceName"
                        name="referenceName"
                        value={formData.referenceName}
                        onChange={handleChange}
                        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent text-sm"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                    Additional Information
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-transparent"
                    placeholder="Any additional information or questions you'd like to share..."
                  ></textarea>
                </div>

                <div className="flex items-center">
                  <input
                    id="terms"
                    name="terms"
                    type="checkbox"
                    required
                    className="h-4 w-4 text-primary focus:ring-primary border-gray-300 rounded"
                  />
                  <label htmlFor="terms" className="ml-2 block text-sm text-gray-700">
                    I agree to the <a href="/terms" className="text-primary hover:underline">Terms and Conditions</a> and 
                    <a href="/privacy" className="text-primary hover:underline"> Privacy Policy</a> *
                  </label>
                </div>

                <div className="pt-4">
                  <button
                    type="submit"
                    disabled={isSubmitting}
                    className={`w-full bg-[#800000] text-white py-3 px-6 rounded-md font-medium hover:bg-[#990000] transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#800000] text-center ${
                      isSubmitting ? 'opacity-75 cursor-not-allowed' : ''
                    }`}
                    style={{ backgroundColor: '#800000' }}
                  >
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Next Steps */}
      <div className="bg-gray-100 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">What Happens Next?</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              After you submit your application, here's what you can expect:
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-primary bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary">1</span>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">Application Review</h3>
              <p className="text-gray-600">Our admissions team will carefully review your application and documents.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-primary bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary">2</span>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">Interview</h3>
              <p className="text-gray-600">You may be invited for an interview with our admissions committee.</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-md text-center">
              <div className="bg-primary bg-opacity-10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-primary">3</span>
              </div>
              <h3 className="text-lg font-medium text-gray-800 mb-2">Admission Decision</h3>
              <p className="text-gray-600">You'll receive our admission decision within 2-4 weeks of your interview.</p>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
};

export default ApplyNow;
